import { SocialIcon } from '@osf/shared/models/socials/social-icon.model';

export const SOCIAL_ICONS: SocialIcon[] = [
  {
    name: 'github',
    iconName: 'fab fa-github',
    url: 'https://github.com/centerforopenscience',
    ariaLabel: 'GitHub',
  },
  {
    name: 'linkedIn',
    iconName: 'fab fa-linkedin-in',
    url: 'https://www.linkedin.com/company/center-for-open-science/',
    ariaLabel: 'Linkedin',
  },
  {
    name: 'bluesky',
    iconName: 'fab fa-bluesky',
    url: 'https://bsky.app/profile/cos.io',
    ariaLabel: 'Bluesky',
  },
  {
    name: 'mastodon',
    iconName: 'fab fa-mastodon',
    url: 'https://fosstodon.org/@CenterforOpenScience',
    ariaLabel: 'Mastodon',
  },
];
